/** Fontes do editor de documentação (sistema Windows + Google Fonts). */
export type DocumentationFontOption = {
  /** Valor no Quill (classe ql-font-{value}). */
  value: string;
  label: string;
  /** CSS font-family aplicado no conteúdo. */
  family: string;
};

export const DOCUMENTATION_FONT_OPTIONS: DocumentationFontOption[] = [
  { value: 'arial', label: 'Arial', family: 'Arial, Helvetica, sans-serif' },
  { value: 'calibri', label: 'Calibri', family: "Calibri, 'Segoe UI', sans-serif" },
  { value: 'segoe-ui', label: 'Segoe UI', family: "'Segoe UI', Tahoma, Geneva, sans-serif" },
  { value: 'tahoma', label: 'Tahoma', family: 'Tahoma, Geneva, sans-serif' },
  { value: 'verdana', label: 'Verdana', family: 'Verdana, Geneva, sans-serif' },
  { value: 'times-new-roman', label: 'Times New Roman', family: "'Times New Roman', Times, serif" },
  { value: 'georgia', label: 'Georgia', family: 'Georgia, serif' },
  { value: 'courier-new', label: 'Courier New', family: "'Courier New', Courier, monospace" },
  { value: 'roboto', label: 'Roboto', family: "'Roboto', Arial, sans-serif" },
  { value: 'open-sans', label: 'Open Sans', family: "'Open Sans', Arial, sans-serif" },
  { value: 'lato', label: 'Lato', family: "'Lato', Arial, sans-serif" },
  { value: 'montserrat', label: 'Montserrat', family: "'Montserrat', Arial, sans-serif" },
  { value: 'poppins', label: 'Poppins', family: "'Poppins', Arial, sans-serif" },
  { value: 'source-sans-3', label: 'Source Sans 3', family: "'Source Sans 3', Arial, sans-serif" },
  { value: 'nunito', label: 'Nunito', family: "'Nunito', Arial, sans-serif" },
  { value: 'pt-sans', label: 'PT Sans', family: "'PT Sans', Arial, sans-serif" },
  { value: 'merriweather', label: 'Merriweather', family: "'Merriweather', Georgia, serif" },
  { value: 'roboto-mono', label: 'Roboto Mono', family: "'Roboto Mono', 'Courier New', monospace" },
];

export const DOCUMENTATION_FONT_WHITELIST = DOCUMENTATION_FONT_OPTIONS.map((f) => f.value);
